import React from "react";
import Contactinfo from "../../../components/customer/contact/Contactinfo";
import Contactform from "../../../components/customer/contact/Contactform";
import Navbar from "../../../components/customer/home/Navbar/MyNavbar";
import Footer from "../../../components/customer/home/footer/Myfooter";
import Topbar from "../../../components/customer/home/topbar/Topbar";
// import CTASection from "../../../subscreens/customer/services/ctasection/CTASection";

const Contact = () => {
  return (
    <>
      <Topbar />
      <Navbar />

      {/* Heading Section */}
     

      <Contactform />
      <Contactinfo />
      <Footer />
    </>
  );
};

export default Contact;